import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { SocialSharing } from "@ionic-native/social-sharing/ngx";

import { AdMobFree } from '@ionic-native/admob-free/ngx';
import { AdmobService } from './service/admob.service';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule, 
  ],
  providers: [
    AdMobFree,
    AdmobService,
    GoogleAnalytics,
    StatusBar,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    SocialSharing,
  ],
  bootstrap: [AppComponent], 
  
})
export class AppModule {}
